export default {
    _prefix: "FormEditorContainer",
    FlipSwitch: {
        PreviewOn: "Preview Form On",
        PreviewOff: "Preview Form Off",
    },
    labels: {
        defaultAssessmentEditorText: "Assessment Form Editor",
        defaultAssessmentPreviewText: "Assessment Form Preview",
        defaultPublishedAssessmentText: "Assessment Form",
        reloadingForm: "Reloading form",
    },
};
